import React, { useEffect } from "react";
import { firestore, messaging } from "./firebaseConfig";
import { getToken, onMessage } from "firebase/messaging";
import { updateFcmToken } from "store/features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { doc, setDoc } from "firebase/firestore";
import { userSelector } from "store/features/authSlice";

const PushNotifications = () => {
  const { uid } = useSelector(userSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!uid) return;

    const requestPermission = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          const token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_VAPID_KEY,
          });

          if (token) {
            dispatch(updateFcmToken({ fcmToken: token }));
            await setDoc(doc(firestore, "fcmTokens", uid), { token });
          } else {
            console.log("Failed to get FCM token");
          }
        } else {
          console.log("Notification permission not granted");
        }
      } catch (error) {
        console.error("Error getting notification permission/token", error);
      }
    };

    requestPermission();

    const unsubscribe = onMessage(messaging, (payload) => {
      const { title, body } = payload.notification;
      new Notification(title, { body });
    });

    return () => unsubscribe();
  }, [uid]);

  return null;
};

export default PushNotifications;
